import React, { useMemo } from 'react';
import PanelHelpBadge from '../../PanelHelpBadge';

function weightedAverage(rows, metricKey) {
  let weighted = 0;
  let total = 0;
  for (const row of rows || []) {
    const weight = Number(row?.sampleSize || 0);
    const value = Number(row?.metrics?.[metricKey]?.value || 0);
    if (weight <= 0) continue;
    weighted += value * weight;
    total += weight;
  }
  return total > 0 ? Number((weighted / total).toFixed(2)) : 0;
}

export default function SessionBehaviorCard({ sessionBehavior = [], onOpenDrawer }) {
  const safeRows = Array.isArray(sessionBehavior) ? sessionBehavior : [];
  const topRows = safeRows.slice(0, 3);

  const summary = useMemo(() => {
    return {
      sessionCount: safeRows.length,
      acceptRate: weightedAverage(safeRows, 'acceptRate'),
      wowRate: weightedAverage(safeRows, 'wowRate'),
      cookRate: weightedAverage(safeRows, 'cookRate')
    };
  }, [safeRows]);

  return (
    <article className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h4 className="text-sm font-black text-slate-900 dark:text-white">Oturum Davranışı</h4>
          <PanelHelpBadge
            title="Oturum Davranışı"
            description="Oturum bazında karar ve pişirme sinyallerini gösterir."
            interpretation="Kısa sürede yüksek kabul alınan oturumlar akış kalitesini işaret eder."
            metricExample="Kabul yüksek ama pişirme düşükse öneri sonrası adımda sürtünme olabilir."
          />
        </div>
        <span className="rounded-full border border-slate-200 px-2 py-0.5 text-[10px] font-bold text-slate-600 dark:border-slate-700 dark:text-slate-300">
          Session Scope
        </span>
      </div>

      <p className="mt-3 text-2xl font-black text-slate-900 dark:text-white">{summary.sessionCount.toLocaleString('tr-TR')}</p>
      <p className="text-xs text-slate-500 dark:text-slate-400">aktif oturum örneği</p>

      <ul className="mt-3 space-y-1.5 text-sm">
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Kabul</span>
          <span className="font-black text-slate-900 dark:text-white">%{summary.acceptRate.toLocaleString('tr-TR')}</span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Wow</span>
          <span className="font-black text-slate-900 dark:text-white">%{summary.wowRate.toLocaleString('tr-TR')}</span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Pişirme</span>
          <span className="font-black text-slate-900 dark:text-white">%{summary.cookRate.toLocaleString('tr-TR')}</span>
        </li>
      </ul>

      <div className="mt-3 space-y-1.5">
        {topRows.length === 0 ? (
          <p className="text-xs text-slate-500 dark:text-slate-400">Bu filtrede oturum verisi bulunmuyor.</p>
        ) : (
          topRows.map((row) => (
            <div key={row.sessionKey} className="rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-xs dark:border-slate-700 dark:bg-slate-800">
              <span className="font-semibold text-slate-700 dark:text-slate-200">{String(row.sessionKey || '').slice(0, 14)}</span>
              <span className="ml-2 text-slate-500 dark:text-slate-400">Kabul %{Number(row?.metrics?.acceptRate?.value || 0).toLocaleString('tr-TR')}</span>
            </div>
          ))
        )}
      </div>

      <div className="mt-3 flex items-center justify-end">
        <button
          type="button"
          onClick={() => onOpenDrawer('session', { sessionBehavior: safeRows })}
          className="text-xs font-bold text-primary hover:underline"
        >
          Detaya git →
        </button>
      </div>
    </article>
  );
}
